import { t } from '../i18n';
import { hrefFor } from '../shell/route';
import { PageHeader } from '../ui';

export function NotFoundScreen() {
  return (
    <>
      <PageHeader title={t('notFound.title')} subtitle={t('notFound.body')} />
      <a href={hrefFor({ name: 'home' })} className="underline">
        {t('notFound.back')}
      </a>
    </>
  );
}
